<template src="./template/index.html"></template>
<script>
import DibbleJS from "../../dibble";
import DibbleApi from "../../api";
import AddCouponModal from "@/components/Coupons/AddCouponModal/AddCouponModal";

export default {
    name: 'Coupons',
    display: "Transition",
    data () {
        return {
            dibbleJs: DibbleJS,
            coupons: [],
            isShowAddCouponModal: false,
            currentUpdateItem: null
        }
    },
    mounted () {
        this.getCouponsList()
    },
    methods: {
        _onSuccess(response) {
            this.dibbleJs.hideLoader();
            if (DibbleApi.isResponseSuccess(response)) {
                this.coupons = response.coupons
            }
        },
        getCouponsList() {
            this.dibbleJs.showLoader();
            const params = {
                request: DibbleApi.api.getCouponsList
            };
            this.dibbleJs.callApiRequest(params, this._onSuccess);
        },
        openModalUpdateCoupon (type, coupon = null) {
            this.isShowAddCouponModal = true
            this.currentUpdateItem = coupon
        },
        couponAdded() {
            this.closeModal()
            this.getCouponsList()
        },
        closeModal () {
            this.isShowAddCouponModal = false
        },
        revokeItem(coupon) {
            this.dibbleJs.showLoader();
            const params = {
                request: coupon['is_revoked'] ? DibbleApi.api.unRevokeCoupon : DibbleApi.api.revokeCoupon,
                coupon_number: coupon['coupon_number']
            };
            this.dibbleJs.callApiRequest(params, (response => {
                DibbleJS.hideLoader();
                if (DibbleApi.isResponseSuccess(response)) {
                    DibbleJS.toastSuccessMessage(response.message)
                    this.getCouponsList()
                } else {
                    DibbleJS.toastErrorMessage(response.message)
                }
            }));
        }
    },
    components: {
        AddCouponModal
    }
}
</script>
<style scoped>
    tr.order-row {
        cursor: pointer;
    }
    tr.order-row:hover {
        background-color: #e1e1e1;
    }
    .btn-4 {
        margin-top: 0px;
    }
    .table th, .table td {
        vertical-align: middle !important;
    }
</style>
